import { client } from '../api/api-client';
import config from '../config';

function registerCompany(body) {
  return client(config.BASE_AUTH_URL, 'registrations/company', { body });
}

export { registerCompany };
